var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F6F8FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0094 20C36.0535 19.998 32.1858 21.1694 28.8958 23.3658C25.6058 25.5622 23.0406 28.685 21.5251 32.3394C20.01 35.9937 19.6125 40.0151 20.3831 43.8958C21.1538 47.7761 23.0578 51.3408 25.8544 54.1387C28.6511 56.9365 32.2146 58.8424 36.0944 59.615C39.9744 60.3875 43.9958 59.9919 47.6509 58.4785C51.306 56.9651 54.4301 54.4018 56.628 51.1128C58.8261 47.8237 59.9994 43.9564 59.9994 40.0007C59.9935 34.6999 57.8861 29.6178 54.1386 25.8685C50.3914 22.1194 45.31 20.0091 40.0093 20.0008L40.0094 20ZM40.0094 58.5407C36.342 58.5427 32.7566 57.457 29.7058 55.4207C26.6553 53.3847 24.2776 50.4897 22.8727 47.1022C21.4678 43.7146 21.0993 39.9864 21.8138 36.3893C22.5281 32.7919 24.2932 29.4875 26.8856 26.8936C29.4782 24.2996 32.7818 22.5328 36.3784 21.8166C39.9751 21.1004 43.7034 21.467 47.092 22.8701C50.4806 24.2731 53.3769 26.6494 55.4149 29.6989C57.4525 32.748 58.5401 36.3331 58.5401 40.0003C58.5343 44.9141 56.5806 49.6253 53.1069 53.101C49.6331 56.5765 44.9233 58.533 40.009 58.5413L40.0094 58.5407ZM52.7044 41.2572H39.9287V27.64V27.6403C39.9287 27.2374 39.6023 26.9106 39.1993 26.9106C38.7964 26.9106 38.4697 27.2374 38.4697 27.6403V41.3789C38.4705 41.7335 38.6114 42.0733 38.8623 42.3239C39.1128 42.5744 39.4527 42.7156 39.8073 42.7162H52.6944C53.0973 42.7162 53.4238 42.3897 53.4238 41.9868C53.4238 41.5839 53.0973 41.2572 52.6944 41.2572L52.7044 41.2572Z",
    fill: "#171D27"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.62835687906254d8a7be3ee53409b25f.svg";
export { ForwardRef as ReactComponent };